<template>
<div class="tv-inner tv-video" :class="{beforeplay: !played, paused: !playing, playing: playing, interactive: interactive}" v-on:mouseover="resetInteractive" v-on:mousemove="resetInteractive" v-on:click="resetInteractive">
  <div class="video-container">
    <video ref="video" :poster="poster" :loop="loop" />
<!--     <img src="http://vid01.pilatesvision.dev.oneit.rs/files/001_12/preview.jpg" /> -->
    <video ref="introoutro" class="introoutro" :class="{ply: introOutroPlaying}" />
  </div>
  <div class="logo"></div>
  <div class="seek-bar" ref="seekbar" v-on:mousedown.prevent="dragStart">
    <div class="seek-progress" :style="{width: time/duration*100+'%'}">
    </div>
    <div class="seek-line" :style="{width: time/duration*100+'%'}">
      <span class="current">{{ formatTime(this.time) }}</span>
      <span class="duration">{{ formatTime(this.duration) }}</span>
    </div>
    <ul class="chapters" v-if="chapters">
      <li v-for="chapter in chapters" :style="{left: calcLeft(chapter.time)}" :class="{'not-passed': !chapter.passed}"></li>
    </ul>
  </div>
  <div class="video-description">
    <div class="tvd-in">
      <slot />
    </div>
  </div>
  <a href="" v-on:click.prevent="playpause" class="playpause"></a>
  <volume-bar v-model="volume" v-if="!edit" />
  <div class="fullsc" v-if="!edit">
    <a class="fs-toggle" :class="{active: isFullScreen}" href="" v-on:click.prevent="toggleFullscreen"></a>
  </div>
</div>
</template>
<script>
import Hls from 'hls.js';
import api from './api';

export default {
  props: ["src", "poster", "edit", "loop", "chapters", "paused", "introVideo", "outroVideo"],
  data: ()=>({
    playing: false,
    played: false,
    loaded: false,
    interactive: true,
    time: 0,
    duration: 0,
    isFullScreen: false,
    volume: 100,
    wasPlaying: false,
    isIntro: false,
    isOutro: false,
    introOutroPlaying: false,
  }),
  watch: {
    volume() {
      this.$refs.video.volume=this.volume/100;
    },
    paused() {
      var video=this.$refs.video;
      if (this.paused && this.playing) {
        this.wasPlaying=true;
        this.playpause();
      } else if (!this.paused && !this.playing) {
        if (this.wasPlaying)
          this.playpause();
        this.wasPlaying=false;
      }
    },
  },
  methods: {
    calcLeft(chapterTime) {
      return (chapterTime/this.duration*100)+"%";
    },
    formatTime(value) {
      if (!isFinite(value))
        return "";
      var m=Math.floor(value/60);
      var s=Math.floor(value%60);
      return m+":"+(s<10?"0":"")+s;
    },
    playIntro() {
      this.isIntro=false;
      this.introOutroPlaying=true;
      this.$refs.introoutro.onerror=()=>{
        this.playpause();
      }
      this.$refs.introoutro.onended=()=>{
        this.playpause();
      }
      this.$refs.introoutro.src=this.introVideo;
      this.$refs.introoutro.currentTime=0;
      this.$refs.introoutro.play();
    },
    playOutro() {
      this.isIntro=false;
      this.introOutroPlaying=true;
      this.$refs.introoutro.onerror=()=>{
        this.playpause();
      }
      this.$refs.introoutro.onended=()=>{
      }
      this.$refs.introoutro.src=this.outroVideo;
      this.$refs.introoutro.currentTime=0;
      this.$refs.introoutro.play();
    },
    playpause() {
      this.introOutroPlaying=false;
      if (this.isIntro)
        return this.playIntro();
      var video=this.$refs.video;
      if (this.playing) {
        video.pause();
        this.clearWatch();
      } else {
        video.play();
        this.startWatch();
      }
      this.resetInteractive();
    },
    resetInteractive() {
      this.interactive=true;
      clearTimeout(this.interactiveTimeout);
      this.interactiveTimeout=setTimeout(()=>{
        this.interactive=!this.playing;
      }, 3000);
    },
    dragStart($event) {
      var innerWidth=this.$refs.seekbar.clientWidth;
      this.startPoint=$event;
//       this.seekStart=this.time;
      this.seekStart=$event.layerX/innerWidth*this.duration;
      this.seekStart=Math.max(0, Math.min(this.duration, this.seekStart));
      this.newTime=this.seekStart;
    },
    dragMove($event) {
      if (!this.startPoint)
        return;
      var movement=$event.clientX-this.startPoint.clientX;
      var innerWidth=this.$refs.seekbar.clientWidth;
      var seekDiff=movement/innerWidth*this.duration;
      this.newTime=this.seekStart+seekDiff;
      this.newTime=Math.max(0, Math.min(this.duration, this.newTime));
      this.time=this.newTime;
    },
    dragEnd($event) {
      if (typeof(this.newTime)=="number") {
        this.clearWatch();
        this.$refs.video.currentTime=this.newTime;
        this.startWatch();
      }
      this.newTime=null;
      this.seekStart=null;
      this.startPoint=null;
    },
    toggleFullscreen() {
      var fse=document.webkitFullscreenElement || document.fullscreenElement;
      if (!fse) {
        this.isFullScreen=true;
        if (this.$el.requestFullscreen)
          this.$el.requestFullscreen();
        else if (this.$el.webkitRequestFullscreen)
          this.$el.webkitRequestFullscreen();
      } else {
        this.isFullScreen=false;
        if (document.exitFullscreen)
          document.exitFullscreen();
        else if (document.webkitExitFullscreen)
          document.webkitExitFullscreen();
      }
    
//       this.isFullScreen=!this.isFullScreen;
    },
    startWatch() {
      this.lastSavePos=this.$refs.video.currentTime || 0;
      this.watchRecordInterval=setInterval(()=>{
        var watchTime=Math.max(0, this.$refs.video.currentTime-this.lastSavePos);
        this.lastSavePos=this.$refs.video.currentTime;
        if (watchTime)
          this.recordWatchTime(watchTime);
      }, 10000);
    },
    clearWatch() {
      clearInterval(this.watchRecordInterval);
      var watchTime=Math.max(0, this.$refs.video.currentTime-this.lastSavePos);
      this.lastSavePos=this.$refs.video.currentTime;
      if (watchTime)
        this.recordWatchTime(watchTime);      
    },
    async recordWatchTime(timeWatched) {
      var user=appData.currentUser.id;
      var video=this.$route.params.id;
      if (this.savedWatch) {
        this.savedWatch.watched=(this.savedWatch.watched*1 || 0)+timeWatched*1;
        api.update("WatchLog", this.savedWatch.id, {watched: this.savedWatch.watched});
      } else {
        this.recordView();
        this.savedWatch=(await api.create("WatchLog", {
          user, video,
          started: "CURRENT_TIMESTAMP",
          watched: timeWatched,
        }, true)).item;
      }
    },
    async recordView() {
      var video=(await api.get("Video", this.$route.params.id)).item;
      if (video)
        api.update("Video", video.id, {views: video.views*1+1});
    }
  },
  mounted() {
    if (this.introVideo)
      this.isIntro=true;
    //this.src="https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8";
    //this.src="demo.mp4";
    //this.src="http://vid01.pilatesvision.dev.oneit.rs/files/001_12/playlist.m3u8"
    if (this.src.indexOf("m3u8")!=-1) {
      if(Hls.isSupported()) {
        var hls = new Hls();
        hls.loadSource(this.src);
        hls.attachMedia(this.$refs.video);
        hls.on(Hls.Events.MANIFEST_PARSED, ()=>{
          this.loaded=true;
        });
      } else
        this.$refs.video.src=this.src;
    } else
      this.$refs.video.src=this.src;
    // https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8
  
  
    this.updateTime=setInterval(()=>{
      if (this.startPoint)
        return;
      this.time=this.$refs.video.currentTime;
      this.duration=this.$refs.video.duration;
      this.$emit("seek", this.time);
      this.$emit("duration", this.duration);
    }, 160);
    this.$refs.video.addEventListener("canplay", ()=>this.loaded=false);
    this.$refs.video.addEventListener("pause", ()=>this.playing=false);
    this.$refs.video.addEventListener("play", ()=>this.playing=this.played=true);
    this.dragMoveHandler=($event)=>this.dragMove($event);
    document.addEventListener("mousemove", this.dragMoveHandler, true);
    this.dragEndHandler=($event)=>this.dragEnd($event);
    document.addEventListener("mouseup", this.dragEndHandler, true);
    
    this.$refs.video.onended=()=>{
      if (this.outroVideo)
        this.playOutro();
    }
  },
  beforeDestroy() {
    this.clearWatch();
  },
  destroyed() {
    clearInterval(this.updateTime);
    document.removeEventListener("mousemove", this.dragMoveHandler);
    document.removeEventListener("mouseup", this.dragEndHandler);
  },
}
</script>
